'use client';

import { useSearchParams } from 'next/navigation';
import { signIn } from 'next-auth/react';
import { useEffect } from 'react';

export default function Login() {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get('callbackUrl');

  useEffect(() => {
    const safeCallback = callbackUrl?.includes('/auth/login')
      ? '/'
      : callbackUrl || '/';
    void signIn('keycloak', { callbackUrl: safeCallback });
  }, [callbackUrl]);

  return null;
}
